var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonIconPrevious(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.36697 16.6003C9.09907 16.8562 8.73577 17 8.35696 17C7.97815 17 7.61484 16.8562 7.34694 16.6003L0.918272 10.4569C0.650452 10.2009 0.5 9.85376 0.5 9.49176C0.5 9.12976 0.650452 8.78258 0.918272 8.52657L7.34694 2.38323C7.61638 2.13455 7.97724 1.99694 8.35182 2.00005C8.72639 2.00316 9.0847 2.14674 9.34957 2.39985C9.61444 2.65297 9.76469 2.99538 9.76794 3.35333C9.7712 3.71127 9.6272 4.05612 9.36697 4.3136L5.49977 8.12657L19.0714 8.12657C19.4503 8.12657 19.8137 8.2704 20.0816 8.52643C20.3495 8.78245 20.5 9.12969 20.5 9.49176C20.5 9.85383 20.3495 10.2011 20.0816 10.4571C19.8137 10.7131 19.4503 10.8569 19.0714 10.8569L5.49977 10.8569L9.36697 14.6699C9.63479 14.9259 9.78524 15.2731 9.78524 15.6351C9.78524 15.9971 9.63479 16.3443 9.36697 16.6003Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonIconPrevious);
export default __webpack_public_path__ + "static/media/buttonIconPrevious.26758b363aa534bd5737a8b5993210ab.svg";
export { ForwardRef as ReactComponent };